<template>
    <div :class="[
    'component',
    'component__modules_item',
    `component__modules_item--${moduleType}`,
    moduleType === 'group' && index.length === 1 ? 'component__modules_item--parent-group' : ''
    ]">
        <template v-if="getModulePending">
            <component-loading></component-loading>
        </template>
        <template v-else>
            <div class="component__modules_item_top">
                <template v-if="moduleType === 'module'">
                    <div class="component__modules_item_top_details">
                        <div class="columns is-block-touch">
                            <template v-if="moduleSubType === 'event'">
                                <div class="column is-narrow column--custom-thumbnail">
                                    <div class="component__modules_item_top_details_thumbnail">
                                        <component-thumbnail
                                            :allow-preview="true"
                                            :id="moduleExtendedDataThumbnail"
                                        ></component-thumbnail>
                                    </div>
                                </div>
                            </template>
                            <div class="column">
                                <div
                                    :key="rerenderIndex"
                                    class="component__modules_item_top_details_name"
                                >
                                    <component-text :size="'medium'">{{ moduleName }}</component-text>
                                </div>
                                <div class="component__modules_item_top_details_info">
                                    <div class="columns is-vcentered is-block-mobile">
                                        <div class="column is-narrow">
                                            <div class="component__modules_item_top_details_info_type">
                                                <component-text
                                                    :icon="true"
                                                    :icon-name="'monitor'"
                                                    :size="'small'"
                                                >{{ moduleSubTypeReadable }}
                                                </component-text>
                                            </div>
                                        </div>
                                        <template v-if="moduleSubType === 'scorm'">
                                            <template v-if="moduleExtendedData">
                                                <template v-if="moduleExtendedDataDuration">
                                                    <div class="column is-narrow">
                                                        <div class="component__modules_item_top_details_info_duration">
                                                            <component-text
                                                                :icon="true"
                                                                :icon-name="'clock'"
                                                                :size="'small'"
                                                            >{{ moduleExtendedDataDuration }}
                                                            </component-text>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-if="moduleExtendedDataLabels">
                                                    <div class="column">
                                                        <div class="component__modules_item_top_details_info_tags">
                                                            <component-text
                                                                :icon="true"
                                                                :icon-name="'tag'"
                                                                :size="'small'"
                                                            >{{ moduleExtendedDataLabels }}
                                                            </component-text>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <component-loading :size="'small'"></component-loading>
                                            </template>
                                        </template>
                                    </div>
                                </div>
                                <template v-if="moduleExtendedDataDescription">
                                    <div class="component__modules_item_top_details_description">
                                        <component-text
                                            :key="rerenderIndex"
                                            :html="true"
                                        >{{ moduleExtendedDataDescription }}
                                        </component-text>
                                    </div>
                                </template>
                                <template v-if="moduleCompletionState && moduleCompletionScore && (isUserEnrolled || routeIsCourseEnrolmentView)">
                                    <div class="component__modules_item_top_details_completion">
                                        <div class="columns is-block-mobile columns--margin-1-mobile is-vcentered">
                                            <template v-if="(routeIsCourseVersionView || routeIsCourseEnrolmentView) && moduleCompletionState">
                                                <div class="column is-narrow">
                                                    <div class="component__modules_item_top_details_status">
                                                        <component-status :status="moduleCompletionState"></component-status>
                                                    </div>
                                                </div>
                                            </template>
                                            <div class="column is-narrow"></div>
                                            <template v-if="moduleCompletionScore">
                                                <div class="column is-narrow">
                                                    <div class="component__modules_item_top_details_score">
                                                        Score - {{ moduleCompletionScore }}%
                                                    </div>
                                                </div>
                                            </template>
                                            <div class="column"></div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div class="column is-narrow column--custom-actions">
                                <div class="component__modules_item_top_details_actions">
                                    <div class="columns is-vcentered">
                                        <template v-if="(moduleSubType === 'event' || moduleSubType === 'dummy') && moduleExtendedDataOccurrences.length">
                                            <div class="column is-narrow">
                                                <component-button
                                                    :name="`component-modules-item-actions-view-sessions-${index}`"
                                                    :theme="'default'"
                                                    :icon="true"
                                                    :icon-align="'right'"
                                                    :icon-name="isMainBoxActive ? 'chevron-up' : 'chevron-down'"
                                                    @click="switchMainBox"
                                                >View sessions
                                                </component-button>
                                            </div>
                                        </template>
                                        <template v-if="moduleSubType === 'scorm'">
                                            <template v-if="moduleExtendedData">
                                                <template v-if="routeIsCourseView">
                                                    <div class="column is-narrow">
                                                        <component-button
                                                            :name="`component-modules-item-actions-preview-${index}`"
                                                            :theme="'default'"
                                                            @click="previewSCORMModule"
                                                        >Preview
                                                        </component-button>
                                                    </div>
                                                </template>
                                                <template v-if="user.isLearner() && isUserEnrolled && moduleExtendedData">
                                                    <div class="column is-narrow">
                                                        <component-button
                                                            :name="`component-modules-item-actions-launch-${index}`"
                                                            :theme="primaryButtonTheme"
                                                            @click="launchSCORMModule"
                                                        >{{ moduleCompletionState === 'completed' || moduleCompletionState === 'failed' ? 'Review' : 'Launch' }}
                                                        </component-button>
                                                    </div>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-if="actionsMoreMenuItems.length">
                                            <div class="column">
                                                <component-button-menu
                                                    :align="'right'"
                                                    :buttons="actionsMoreMenuItems"
                                                    :name="`component-modules-item-actions-more-${index}`"
                                                    @emit-view-event="performRedirectToEvent"
                                                    @emit-preview="previewSCORMModule"
                                                    @emit-check-my-answers="performRedirectToCourseAnswers"
                                                ></component-button-menu>
                                            </div>
                                        </template>
                                    </div>
                                    <div class="columns">
                                        <div class="column"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="moduleType === 'group'">
                    <div class="columns">
                        <div class="column">
                            <div class="component__modules_item_top_title">{{ moduleName }}</div>
                        </div>
                        <div class="column is-narrow">
                            <div class="component__modules_item_top_toggle">
                                <component-button
                                    :class="'component__modules_item_top_toggle_button'"
                                    :name="`component-module-item-top-toggle-button-${index.join('-')}`"
                                    :icon="true"
                                    :icon-name="isMainBoxActive ? 'chevron-down' : 'chevron-right'"
                                    :theme="'default'"
                                    @click="switchMainBox"
                                ></component-button>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div
                v-show="isMainBoxActive"
                class="component__modules_item_main"
            >
                <template v-if="moduleType === 'group'">
                    <component-modules
                        :modules="moduleModules"
                        :index="index"
                    ></component-modules>
                </template>
                <template v-else-if="(moduleSubType === 'event' || moduleSubType === 'dummy') && moduleExtendedDataOccurrences.length">
                    <div class="component__modules_item_main_sessions">
                        <div class="columns is-multiline is-variable is-8">
                            <template v-for="(item, index) in moduleExtendedDataOccurrences">
                                <div
                                    :key="index"
                                    class="column is-12-desktop is-6-widescreen is-4-fullhd"
                                >
                                    <component-modules-item-session
                                        v-if="isMainBoxActive"
                                        :key="index"
                                        :item="item"
                                        @emit-booking="getEventModule"
                                    ></component-modules-item-session>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else-if="moduleType === 'note'">
                    <div class="component__modules_item_main_description">
                        <component-text :size="'small'">Note:</component-text>
                        <component-text>{{ moduleDescription }}</component-text>
                    </div>
                </template>
            </div>
        </template>
        <pop-notify
            ref="refreshnotify"
            :title-text="''"
            :content-text="'Your course was launched in another window, please refresh this page to see the updated status.'"
            :cancel-button-active="false"
            :submit-button-text="'Refresh'"
            :icon="true"
            :icon-name="'rotate-cw'"
            :align="'centered'"
            :close-button-active="false"
            @emit-close="performRefreshPage"
            @emit-submit="performRefreshPage"
        ></pop-notify>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentThumbnail from '@/components/default/shared/ComponentThumbnail'
import ComponentStatus from '@/components/default/shared/ComponentStatus'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import ComponentText from '@/components/default/shared/ComponentText'
import { User } from '@/User'
import ComponentModulesItemSession from '@/components/default/shared/ComponentModulesItemSession'
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import PopNotify from '@/components/default/shared/PopNotify'

export default {
  name: 'component-modules-item',
  components: {
    PopNotify,
    ComponentLoading,
    ComponentModulesItemSession,
    ComponentText,
    ComponentButtonMenu,
    ComponentStatus,
    ComponentThumbnail,
    ComponentModules: () => import('@/components/default/shared/ComponentModules'),
    ComponentButton
  },
  data () {
    return {
      user: new User(),
      isMainBoxActive: true,
      getModulePending: false,
      rerenderIndex: 0,
      refreshInterval: 0
    }
  },
  props: {
    index: {
      type: Array,
      default: () => []
    },
    module: {
      type: Object,
      required: true
    }
  },
  computed: {
    routeIsCourseView () {
      return this.$route.name === 'ebs-course-show'
    },
    routeIsCourseVersionView () {
      return this.$route.name === 'ebs-course-version-show'
    },
    routeIsCourseEnrolmentView () {
      return this.$route.name === 'ebs-course-enrolment-show'
    },
    moduleType () {
      return this.module.type
    },
    moduleSubType () {
      return this.module.subType
    },
    moduleNodeIds () {
      return this.module.nodeIds
    },
    modulePreviewId () {
      return this.module.previewId
    },
    moduleSubTypeReadable () {
      let outputStr = ''
      switch (this.moduleSubType) {
        case 'dummy':
          outputStr = 'Event'
          break
        case 'event':
          outputStr = 'Event'
          break
        case 'scorm':
          outputStr = 'Digital learning'
          break
        default:
          outputStr = 'Module'
          break
      }
      return outputStr
    },
    moduleVersionNumber () {
      return this.module.extendedData.versions && this.module.extendedData.versions.length ? this.module.extendedData.versions[0].versionNumber : undefined
    },
    moduleName () {
      let str = ''

      if (this.module.type === 'module' && this.routeIsCourseView && this.moduleVersionNumber) {
        str += `${this.module.extendedData.name} (${this.moduleVersionNumber})`
      } else {
        str = this.module.name
      }

      return str
    },
    moduleId () {
      return this.module.id
    },
    moduleModuleId () {
      return this.module.moduleId
    },
    moduleDescription () {
      return this.module.description
    },
    moduleExtendedDataAdditionalDataIsMultiscorm () {
      const extendedData = this.module.extendedData
      const additionalData = extendedData ? extendedData.additionalData : null
      return additionalData ? additionalData.isMultiscorm : false
    },
    moduleExtendedDataDuration () {
      return this.module.extendedData.duration
    },
    moduleExtendedDataDescription () {
      return this.module.extendedData.description
    },
    moduleExtendedDataLabels () {
      return this.module.extendedData.labels ? this.module.extendedData.labels.map(obj => Object.values(obj)[0]).join(', ') : null
    },
    moduleModules () {
      return this.module.nodes
    },
    moduleExtendedData () {
      return this.module.extendedData
    },
    moduleCompletionState () {
      const history = this.module.history
      return history ? history.completionState : ''
    },
    moduleCompletionScore () {
      const history = this.module.history
      return history ? history.completionPercentage : ''
    },
    moduleExtendedDataStatus () {
      return this.module.extendedData.status || 'not-started'
    },
    moduleExtendedDataHasBookings () {
      return this.moduleExtendedDataOccurrences.findIndex(obj => obj.userBookingStatus === 'booked') > -1
    },
    moduleExtendedDataSCORMId () {
      return this.module.extendedData.content
    },
    moduleExtendedDataSCORMBucketUrl () {
      return this.module.extendedData.scormBucketUrl
    },
    moduleExtendedDataThumbnail () {
      const extendedData = this.module.extendedData
      let thumbnailId

      if (this.moduleSubType === 'event' || this.moduleSubType === 'dummy') {
        thumbnailId = extendedData ? (extendedData.images && extendedData.images.length ? extendedData.images[0].imageId : '') : ''
      } else if (this.moduleSubType === 'scorm') {
        thumbnailId = extendedData ? extendedData.image : ''
      }

      return thumbnailId
    },
    moduleExtendedDataWorkspaceId () {
      return this.module.extendedData.workspaceId
    },
    moduleExtendedDataOccurrences () {
      let occurrences = this.module && this.module.extendedData && this.module.extendedData.occurrences ? JSON.parse(JSON.stringify(this.module.extendedData.occurrences)) : []
      for (let i in occurrences) {
        occurrences[i].workspaceId = this.moduleExtendedDataWorkspaceId
        occurrences[i].eventStatus = this.moduleExtendedDataStatus
      }
      return occurrences
    },
    moduleExtendedDataEventId () {
      return this.module.extendedData ? this.module.extendedData.id : ''
    },
    moduleFirstToLaunch () {
      return this.$store.getters.getEbsCourseModulesFirstToLaunch
    },
    currentWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    actionsMoreMenuItems () {
      let itemsArr = []

      if (this.moduleSubType === 'event' || this.moduleSubType === 'dummy') {
        itemsArr.push({
          key: 'view-event',
          name: 'View event'
        })
      }

      return itemsArr
    },
    isUserEnrolled () {
      return this.$store.getters.getEbsEnrolmentIsUserEnrolled
    },
    userLatestEnrolmentId () {
      return this.$store.getters.getEbsCatalogItemLatestEnrolmentId
    },
    isCourseMode () {
      return this.user.isCourseCreator() || this.user.isCourseLicenceManager() || this.user.isLearningExperienceAdministrator()
    },
    primaryButtonTheme () {
      let buttonTheme = ''
      if (
        this.moduleFirstToLaunch === this.moduleId &&
      (
        this.moduleCompletionState !== 'completed' &&
      this.moduleCompletionState !== 'failed'
      )
      ) {
        buttonTheme = 'primary'
      } else {
        buttonTheme = 'default'
      }
      return buttonTheme
    }
  },
  methods: {
    startRefreshTokensInterval () {
      this.refreshInterval = setInterval(this.refreshTokens, 60000 * 10)
    },
    stopRefreshTokensInterval () {
      clearInterval(this.refreshInterval)
    },
    refreshTokens () {
      this.$store.dispatch('authUserRefreshFirstStageToken').then(() => {
        this.$store.dispatch('authUserRefreshSecondStageToken')
      })
    },
    getEventModule () {
      this.getModulePending = true
      this.$store.dispatch('ebsCourseExtendModule', { moduleType: 'event', moduleId: this.moduleExtendedData.id }).finally(() => {
        this.getModulePending = false
      })
    },
    launchSCORMModule () {
      const scormType = this.moduleExtendedDataAdditionalDataIsMultiscorm ? 'multiscorm' : 'scorm'
      const redirectWindow = window.open(`${this.moduleExtendedDataSCORMBucketUrl}/${scormType}.html?enrolmentId=${this.userLatestEnrolmentId}&courseContentTreeNodeId=${this.moduleNodeIds[0]}`, '_blank', 'menubar=no,toolbar=no')
      if (this.moduleCompletionState !== 'completed' && this.moduleCompletionState !== 'failed') {
        this.openRefreshNotify()
      }
      this.windowTimer = setInterval(function () {
        if (redirectWindow.closed) {
          clearInterval(this.windowTimer)
          this.performRefreshPage()
        }
      }.bind(this), 2000)
    },
    previewSCORMModule () {
      window.open(`${this.moduleExtendedDataSCORMBucketUrl}/preview.html?id=${this.moduleExtendedDataSCORMId}`, '_blank', 'menubar=no,toolbar=no')
    },
    enableMainBox () {
      this.isMainBoxActive = true
    },
    disableMainBox () {
      this.isMainBoxActive = false
    },
    switchMainBox () {
      this.isMainBoxActive = !this.isMainBoxActive
    },
    openRefreshNotify () {
      this.$refs.refreshnotify.openNotify()
      this.refreshTokens()
      this.startRefreshTokensInterval()
    },
    performRedirectToEvent () {
      this.$router.push({ name: 'ebs-event-show', params: { id: this.moduleExtendedDataEventId } })
    },
    performRedirectToCourseAnswers () {

    },
    performRefreshPage () {
      this.stopRefreshTokensInterval()
      this.$router.go()
    }
  },
  watch: {
    moduleName (value) {
      this.rerenderIndex++
    }
  },
  created () {
    this.stopRefreshTokensInterval()
  },
  mounted () {
    if (this.moduleSubType === 'scorm' || this.moduleSubType === 'event' || this.moduleSubType === 'dummy') {
      this.disableMainBox()
    }
  },
  beforeDestroy () {
    this.stopRefreshTokensInterval()
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentmodulesitem";
</style>
